module.exports = __webpack_public_path__ + "img/DirectDeposit-icon.319e44f3.svg";